export default __webpack_public_path__ + "static/media/08.90431342.jpg";